import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { formsAPI } from '../services/api';

const FormResolver = ({ children, redirectTo = '/form' }) => {
  const { id } = useParams();
  const [resolvedId, setResolvedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const resolveForm = async () => {
      try {
        setLoading(true);
        
        // Check if it's a UUID (default format)
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (uuidRegex.test(id)) {
          // It's a UUID, use it directly
          setResolvedId(id);
        } else {
          // It's a custom URL, need to find the form by custom_url
          const response = await formsAPI.getByCustomUrl(id);
          if (response.data.success && response.data.data) {
            setResolvedId(response.data.data.id);
          } else {
            setError('Form not found');
          }
        }
      } catch (err) {
        console.error('Error resolving form:', err);
        setError('Form not found');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      resolveForm();
    }
  }, [id]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#6b7280'
      }}>
        Loading form...
      </div>
    );
  }

  if (error || !resolvedId) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#6b7280'
      }}>
        Form not found or unavailable.
      </div>
    );
  }

  // Clone children and pass the resolved ID
  return React.cloneElement(children, { formId: resolvedId });
};

export default FormResolver;

